import { useSearchParams } from 'next/navigation'

export const useRemovePackagesForExpaExperimentIsExpaPresentInUrl =
  (): boolean => {
    const searchParams = useSearchParams()
    const expaValue = searchParams.get('expa')

    const expasToDisplaySingleVariant: string[] = ['gglp', 'tro']

    return expasToDisplaySingleVariant.includes(expaValue ?? '')
  }
